import DocumentView from './DocumentView';
import HorizontalCardIconFactory from '../shared/HorizontalCardIconFactory';
import MicroIcon from '../shared/MicroIcon';
import DocumentViewDetails from './DocumentViewDetails';
import Icon from 'components/Icon';

const Micro = MicroIcon(Icon.OPTIONS.CARD_FILE);

export const card = DocumentView;
export const details = DocumentViewDetails;
export const micro = Micro;
export const icon = Micro;
export const horizontal = HorizontalCardIconFactory(Micro);
export const preview = DocumentView;
